<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">清除缓存</h1>
		<h3 class="doc_main_h3">（1）清除人脸检测跟踪缓存</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			在检测背景发生大的变化的时候（例如前后摄像头切换后），或者突然临时需要中断视频流的送入时, 为了避免由于人脸跟踪造成错误错勿检测，可调用该接口清除检测跟踪缓存，重新检测跟踪。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceResetDetectBuffer()</code></pre>
		<h3 class="doc_main_h3">参数</h3>
		<p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceResetDetectBuffer();</code></pre>
		<h3 class="doc_main_h3">（2）清除人脸识别缓存</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			识别结果里FaceName非空情况下不会再次进行人脸识别，表示已确认识别人的身份为“陌生人”或者“认识的人”，在如果希望重新进行人脸识别的场景下，可调用该接口清除掉人脸识别缓存，重新进行人脸识别。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceResetRecognizeBuffer()</code></pre>
		<h3 class="doc_main_h3">参数</h3>
		<p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceResetRecognizeBuffer();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','拓展接口','清除缓存'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/expand/Clearcache.vue